import { render } from "./CurrentHeader.vue?vue&type=template&id=74c1ac2e&scoped=true"
import script from "./CurrentHeader.vue?vue&type=script&lang=js"
export * from "./CurrentHeader.vue?vue&type=script&lang=js"

import "./CurrentHeader.vue?vue&type=style&index=0&id=74c1ac2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1ac2e"]])

export default __exports__